<template>
    <div class="homepage-events" id="homepage-events" v-images-loaded:on.progress="relayout">
        <div id="search-bar" v-if="!nosearch">
            <form>
                <div class="row">
                    <div class="col-lg-2 col-md-6">
                        <div class="inner">
                            <datepicker format="dd.MM.yyyy" v-model="start_date"></datepicker>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6">
                        <div class="inner">
                            <selector
                                v-model="selectedCategories"
                                :items="all_categories"
                                defaultText="Alle Kategorien"
                            ></selector>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="inner">
                            <selector
                                v-model="selectedSources"
                                :items="all_sources"
                                defaultText="Alle Veranstalter"
                            ></selector>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6">
                        <input
                            type="text"
                            name="tribe-bar-search"
                            id="tribe-bar-search"
                            v-model="search"
                            aria-label="Suche nach Veranstaltungen als Schlüsselwort."
                            value
                            placeholder="Suchbegriff"
                        />
                    </div>
                    <div class="col-lg-3 offset-lg-0 offset-md-3 col-md-6">
                        <a @click="submit()" class="submit-button search-button">
                            <div v-if="loading" class="lds-ring"><div></div><div></div><div></div><div></div></div>
                            <span v-else>Termin finden</span>
                        </a>
                    </div>
                </div>
            </form>
        </div>

        <div class="homepage-events-listing">
            <div class="events-grid-sizer"></div>
            <Event
                v-for="event in shown_events"
                :key="event._id"
                :id="'event-' + event._id"
                :event="event"
            ></Event>

            <div class="events-gutter-sizer"></div>
        </div>
        <div v-if="!shown_events.length && !loading" id="nothing">
            Leider wurden zu dieser Suchanfrage keine Termine gefunden.   
        </div>
        <nav
            v-if="!loading && !nonav"
            class="tribe-events-nav-pagination"
            aria-label="Veranstaltungen Listennavigation"
        >
            <button
                @click="goto(page+1)"
                v-if="page<total_pages && total_pages>1"
                style="cursor: pointer;"
                class="btn btn-secondary float-right search-button"
            >&gt;</button>
            <button
                v-if="page>1"
                @click="goto(page-1)"
                style="cursor: pointer;"
                class="btn btn-secondary float-left search-button"
            >&lt;</button>
        </nav>
    </div>
</template>

<script>
import _ from "lodash";
import Isotope from "isotope-layout";
import imagesLoaded from "vue-images-loaded";
import Datepicker from "vuejs-datepicker";

import Selector from "@/components/Selector";
import Event from "@/components/Event";

const SOURCES = {
    'septemberspecial': 'Aachen September Special',
    'kurhaus': 'Altes Kurhaus',
    'centrecharlemagne': 'Centre Charlemagne',
    'chorbiennale': 'Chorbiennale',
    'couven': 'Couven Museum',
    'izm': 'Intern. Zeitungsmuseum',
    'ludwigforum': 'Ludwig Forum',
    'schrittmacher': 'schrit_tmacher festival',
    'suermondt': 'Suermondt-Ludwig-Museum',
}
export default {
    name: "CalendarView",
    directives: {
        imagesLoaded
    },
    props: {
        exhibits: {
            type: Boolean,
            default: false,
        },
        nonav: {
            type: Boolean,
            default: false,
        },
        nosearch: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            default: 20,
        }
    },
    async mounted() {
        const that = this
        if (this.exhibits) {
            await this.axios
                .get("https://api.kulturkalender-aachen.de/events?is_ausstellung=1")
                .then(function (response) {
                    that.events = response.data.events;
                    that.compute_events()
                })
        } else {
            await this.axios
                .get("https://api.kulturkalender-aachen.de/events?is_ausstellung=0")
                .then(function (response) {
                    that.events = response.data.events;
                    that.compute_events()
                })

        }
        const elem = document.querySelector(".homepage-events-listing");
        this.iso = new Isotope(elem, {
            itemSelector: ".event-item",
            percentPosition: true,
            masonry: {
                columnWidth: ".events-grid-sizer",
                gutter: ".events-gutter-sizer"
            }
        });
        this.iso.layout();
    },
    methods: {
        submit() {
            this.loading = true
            this.show_theater = false // only show on start screen
            window.location = "#termine"
            window.setTimeout(this.compute_events, 300)
        },
        goto(p) {
            this.page = p
            this.compute_events()
            window.location = "#termine"
        },
        relayout() {
            const elem = document.querySelector(".homepage-events-listing");
            this.iso = new Isotope(elem, {
                itemSelector: ".event-item",
                percentPosition: true,
                masonry: {
                    columnWidth: ".events-grid-sizer",
                    gutter: ".events-gutter-sizer"
                }
            });
            this.iso.layout();
        },
        compute_events() {
            const that = this
            function pred(e) {
                const s = that.search.trim().toLowerCase()
                const st = [e.venue, e.title, e.main_cat, e.source].join(" ").toLowerCase()
                const has_term = !s || st.indexOf(s) >= 0
                const has_cat = _.includes(that.selectedCategories, e.main_cat) || !that.selectedCategories.length
                const has_venue = _.includes(that.selectedSources, e.source) || !that.selectedSources.length
                const is_date = Date.parse(e.start_date_raw) >= that.start_date || that.show_theater
                return has_cat && has_venue && is_date && has_term
            }

            const start = (this.page - 1) * this.count
            this.filtered_events = _.filter(this.events, pred)
            this.shown_events = this.filtered_events.slice(start, start + this.count)
            this.loading = false
        },
    },
    components: {
        Datepicker: Datepicker,
        Selector: Selector,
        Event: Event,
    },
    computed: {
        total_pages() {
            return Math.ceil(this.filtered_events.length / this.count)
        },
        all_categories() {
            // return all the categories we received
            function mapper(a) {
                return {
                    text: a,
                    value: a
                };
            }
            return _(this.events)
                .map("main_cat")
                .uniq()
                .map(mapper)
                .sortBy(['text'])
                .value();
        },
        all_sources() {
            // return all the sources we received
            function mapper(a) {
                return {
                    text: SOURCES[a],
                    value: a
                };
            }
            const not_allowed = ['theater', 'ownevents']
            return _(this.events)
                .map("source")
                .uniq()
                .filter(function(o) {return !not_allowed.includes(o)})
                .map(mapper)
                .sortBy(['text'])
                .value();
        }
    },
    updated() {
        this.relayout()
    },
    data() {
        return {
            loading: true,
            date: "",
            iso: null,
            search: "",
            page: 1,
            start_date: new Date(),
            events: [],
            filtered_events: [],
            shown_events: [],
            selectedSources: [],
            selectedCategories: [],
            show_theater: true,
        };
    }
};
</script>
<style lang="scss">
.loader {
    margin: 0 auto;
    text-align: center;
    position: relative;
    left: -5px;
}
.events-grid-sizer {
    width: 32%;
}
.events-gutter-sizer {
    width: 2%;
}

.event-item {
    display: block;
    border-bottom: 0;
    box-sizing: border-box;
    margin: 0;
    margin-bottom: 20px;
    padding: 0;

    .event-item-link {
        background: white;
        display: block;
        padding: 20px;
        color: #363636;
        text-decoration: none;
    }

    .event-venue {
        font-family: Transit Bold, Helvetica Neue, Arial, sans-serif;
        font-size: 20px;
        line-height: 1.2em;
    }

    .event-category {
        margin-top: 10px;
        font-family: The Mix Black, Transit Regular, Helvetica Neue, Arial,
            sans-serif;
        font-weight: 400;
        color: #fff;
        background: #363636;
        padding: 5px 10px;
        display: inline-block;
        -webkit-font-smoothing: antialiased;
    }
    .event-title {
        font-family: The Mix Black, Transit Regular, Helvetica Neue, Arial,
            sans-serif;
        font-size: 28px;
        color: #363636;
        font-weight: 400;
        margin-top: 10px;
        word-wrap: break-word;
    }
    .event-date {
        font-family: Transit Bold, Helvetica Neue, Arial, sans-serif;
        font-size: 20px;
        line-height: 1.2em;
    }
    .cta {
        color: #fff;
        background-color: #e5c500;
        border-color: #e5c500;
        display: inline-block;
        font-weight: 400;
        line-height: 1.25;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: 0.5rem 1rem;
        font-size: 1rem;
        transition: all 0.2s ease-in-out;
        font-family: The Mix Black;
        text-align: center;
        padding: 10px 20px;
        font-size: 20px;
        margin-top: 1rem;
    }
}

.clearfix {
    overflow: auto;
}
.clearfix::after {
    content: "";
    clear: both;
    display: table;
}
.vdp-datepicker__calendar {
    left: 10px;
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.3);
}

.select-field {
    width: 100%;
    height: 50px;
    padding: 10px;
    font-size: 15px;
    background: #fff;
    color: #363636;
    text-align: left;
    font-family: The Mix Black, Transit Regular, Helvetica Neue, Arial,
        sans-serif;
    font-weight: 400;
    height: 50px;
}
.select-field:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.1em;
    vertical-align: middle;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-left: 0.3em solid transparent;
}
#search-bar {
    margin-bottom: 30px;
    .inner {
        background: #fff;
        color: #363636;
        border: 1px solid #363636;
    }
    input[type="text"] {
        padding: 15px 10px;
        font-size: 15px;
        width: 100%;
        height: 50px;
        color: #000;
        font-style: normal;
        background: #fff;
        border: none;
        font-family: The Mix Light, Transit Regular, Helvetica Neue, Arial,
            sans-serif;
        font-weight: 400;
    }
    .search-button {
        overflow: hidden;
        display: inline-block;
        font-size: 20px;
        background-color: #e5c500;
        border-color: #e5c500;
        padding: 12px 20px;
        width: 100%;
        height: 50px;
        color: #fff !important;
        text-align: center;
        font-weight: 400;
        font-family: The Mix Black, Transit Regular, Helvetica Neue, Arial,
            sans-serif;
    }
    a {
        cursor: pointer;
    }
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 25px;
    height: 25px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 2px;
    border: 2px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
